import React, { memo } from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';

import { columns } from './LoanConditionInfoTable.constants';

const LoanConditionInfoTableHead = () => (
  <TableHead>
    <TableRow className="h-64 uppercase">
      {columns.map(({ align, id, label, className }) => (
        <TableCell align={align} className={className} key={id}>
          {label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

export default memo(LoanConditionInfoTableHead);
